import { FilterCondition, FilterRules } from "@infologistics/frontend-libraries";
import { DayOptions, MonthOptions, WeekOptions } from "./translations";

export enum Day {
  TODAY = "today",
  TOMORROW = "tomorrow",
  YESTERDAY = "yesterday",
}

export const DayValues = [Day.YESTERDAY, Day.TODAY, Day.TOMORROW];
export const DayShortValues = [Day.YESTERDAY, Day.TODAY];

export enum Week {
  NEXTWEEK = "nextweek",
  PREVWEEK = "prevweek",
  THISWEEK = "thisweek",
}

export const WeekValues = [Week.PREVWEEK, Week.THISWEEK, Week.NEXTWEEK];
export const WeekShortValues = [Week.THISWEEK, Week.PREVWEEK];

export enum Month {
  NEXTMONTH = "nextmonth",
  PREVMONTH = "prevmonth",
  THISMONTH = "thismonth",
}

export const MonthValues = [Month.PREVMONTH, Month.THISMONTH, Month.NEXTMONTH];
export const MonthShortValues = [Month.THISMONTH, Month.PREVMONTH];

export enum FilterName {
  QUERY = "query",
  QUERY_LIKE = "query.like",
  VALUE_LIKE = "value.like",
}

// Правила для фильтров с типом Дата
export const FILTER_DATE_RULES = {
  [FilterCondition.ALL]: FilterRules.ALL,
  [FilterCondition.BEFORE]: FilterRules.DATE,
  [FilterCondition.EQ]: FilterRules.DATE,
  [FilterCondition.AFTER]: FilterRules.DATE,
  [FilterCondition.BETWEEN]: FilterRules.DATE,
  [FilterCondition.DAY]: FilterRules.SELECT,
  [FilterCondition.LESS]: FilterRules.CURRENCY,
  [FilterCondition.WEEK]: FilterRules.SELECT,
  [FilterCondition.MONTH]: FilterRules.SELECT
}

// Опции дней-недель-месяцев для фильтров с типами Дата/Дата-Время
export const FILTER_DATE_TIME_OPTIONS = {
  [FilterCondition.DAY]: DayValues.map((value) => ({
    label: DayOptions[value],
    value: value
  })),
  [FilterCondition.MONTH]: MonthValues.map((value) => ({
    label: MonthOptions[value],
    value: value
  })),
  [FilterCondition.WEEK]: WeekValues.map((value) => ({
    label: WeekOptions[value],
    value: value
  }))
}
